// extracted by mini-css-extract-plugin
module.exports = {"container":"footer_container__1omAh","gonganju":"footer_gonganju__1koR_","gonganjuImg":"footer_gonganjuImg__tHquF"};